import { FinePrints } from '../fine-print/fine-print.service';
import { AccountId } from '../../domain/account.domain';
import { Currency } from '../../domain/market.domain';
import { WeightedReturnType } from '../../domain/weighted-return-type.domain';
import { RestParams } from '../../services/rest/rest-request';

export { WeightedReturnType } from '../../domain/weighted-return-type.domain';

export enum PerformanceTimeRange {
  LAST_WEEK = 'LAST_WEEK',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
  LAST_3_YEARS = 'LAST_3_YEARS',
  LAST_5_YEARS = 'LAST_5_YEARS',
  LAST_10_YEARS = 'LAST_10_YEARS',
  YEAR_TO_DATE = 'YEAR_TO_DATE',
  SINCE_GOAL_CREATION = 'SINCE_GOAL_CREATION',
  SINCE_INCEPTION = 'SINCE_INCEPTION',
  CUSTOM = 'CUSTOM'
}

/**
 * Params for Chart Data and Period Data
 */
export interface PerformanceParams extends RestParams {
  accountId: AccountId | Array<AccountId>;
  annualTarget?: number;
  currencies?: Array<Currency>;
  startDate?: Date;
  endDate?: Date;
  period?: PerformanceTimeRange;
  weightedReturnType?: WeightedReturnType;
}

/**
 * Performance chart data
 */
export interface ChartData {
  balanceTrendChart?: BalanceTrendChartData;
  currency?: Currency;
  startDate?: Date;
  endDate?: Date;
  rateOfReturnChart?: RateOfReturnChartData;
  weightedReturnType?: WeightedReturnType;
  fineprints?: FinePrints;
}

export interface ChartDataPoint {
  x: number;
  y: number;
}

export interface BalanceTrendChartData {
  DOLLAR_PORTFOLIO?: Array<BalanceTrendChartPoint>;
}

export interface BalanceTrendChartPoint {
  date?: Date;
  endingBalance?: number;
  marketChange?: number;
  startingBalance?: number;
  value?: number;
}

export interface RateOfReturnChartData {
  ANNUAL_TARGET?: Array<RateOfReturnChartPoint>;
  PERCENT_PORTFOLIO?: Array<RateOfReturnChartPoint>;
  PERCENT_SP500?: Array<RateOfReturnChartPoint>;
  PERCENT_TMX_COMPOSITE?: Array<RateOfReturnChartPoint>;
}
// TODO: should be the same for all chart data
export interface RateOfReturnChartPoint {
  date?: Date;
  value?: number;
}

export interface PeriodData {
  asOfDate?: Date;
  balanceTrend?: Partial<Record<PerformanceTimeRange, BalanceTrendPeriodData>>;
  currency?: Currency;
  fineprints?: FinePrints;
  inceptionDate?: Date;
  rateReturn?: Partial<Record<PerformanceTimeRange, RateReturnPeriodData>>;
  weightedReturnType?: WeightedReturnType;
}

export interface BalanceTrendPeriodData {
  changeBalancePercent?: number;
  changeBalanceValue?: number;
  changeInMarketValue?: number;
  depositsTransferIn?: number;
  dollarPortfolioReturn?: number;
  endingBalance?: number;
  investmentIncome?: number;
  startingBalance?: number;
  weightedReturnType?: WeightedReturnType;
  withdrawalTransferOut?: number;
}

export interface RateReturnPeriodData {
  percentAnnual?: number;
  percentReturn?: number;
}
